import { observable, toJS, makeAutoObservable } from "mobx";
import _ from "lodash";
import { gql } from "@apollo/client";

class User {
	@observable data = null;
	@observable type = null;
	@observable info = null;
	@observable businessId = null;
	@observable subscription = null;

	constructor() {

		makeAutoObservable(this);

		this.setData = (data) => {
			return new Promise((resolve) => {
				this.data = data;
				setTimeout(() => {
					resolve(true);
				}, 100);
			});
		};

		this.setBusinessId = (id) => {
			this.businessId = id;
		}

		this.getToken = () => {
			return this.data.token;
		};

		this.setLogin = async (data, client) => {
			return new Promise(async (resolve, reject) => {
				try {
					//
					// Set User Data
					//
					const {businessId, ...userdata} = data;
					await localStorage.setItem("user", JSON.stringify(userdata));
					if(businessId) await localStorage.setItem("businessId", businessId);
					this.data = data;

					//
					// Get User Type
					//

					const type = await client
						.query({
							query: gql`
								query GetUserType {
									GetUserType {
										type
										subtype
									}
								}
							`,
							fetchPolicy: "no-cache",
						})
						.then(({ data }) => data.GetUserType);
					this.info = type;

					//
					// Resolve
					//

					resolve(true);
				} catch (e) {
					console.log(e);
					reject(e);
				}
			});
		};

		this.check = async (client) => {
			return new Promise(async (resolve, reject) => {
				try {
					let currentData = localStorage.getItem("user");
					if (!currentData) return reject(false);
					let data = JSON.parse(currentData);

					client
						.query({
							query: gql`
								query AuthCheck($token: String!) {
									AuthCheck(token: $token) {
										pending
										result
									}
								}
							`,
							fetchPolicy: "no-cache",
							variables: {
								token: data.token,
							},
						})
						.then(async (result) => {
							if (!result.error) {
								if (result?.data?.AuthCheck.result) {
									this.data = data;

									let currentBusiness = await localStorage.getItem("businessId");
									if(currentBusiness) this.businessId = currentBusiness;

									resolve(result.data.AuthCheck);
								} else {
									reject(false);
								}
							} else {
								reject(false);
							}
						})
						.catch((e) => {
							reject("server_error");
						});
				} catch (e) {
					reject(false);
				}
			});
		};

		this.logout = () => {
			return new Promise(async (resolve, reject) => {
				try {
					localStorage.removeItem("user");
					localStorage.removeItem("businessId");
					resolve(true);
				} catch (e) {
					reject(e);
				}
			});
		};

		this.get = (path) => {
			return _.get(toJS(this.data), path);
		};
		this.set = (path, value) => {
			return _.set(this.data, path, value);
		};
	}
}

const user = new User();
export default user;



